<template>
	<div class="plombs_maker fs-xl">
		<b-overlay :show="is_load" rounded="sm">
			<b-container fluid>
				<h1 class="title text-center pb-5 mt-5">Створення</h1>
				<b-row class="doc_title">
					<b-col lg="12" xl="12" xs="12" sm="12">
						<b-container fluid>
							<b-row class="doc_title mt-3">
								<b-col sm="3">
									<label for="doc_title">Назва *</label>
								</b-col>
								<b-col sm="4">
									<b-form-input :state="is_valid_name" v-model="form.name" maxlength="130" id="doc_title" size="sm"></b-form-input>
									<b-form-invalid-feedback id="input-live-feedback">
										Потрібно заповнити назву
									</b-form-invalid-feedback>
								</b-col>
							</b-row>

							<b-row class="doc_title_s mt-3">
								<b-col sm="3">
									<label for="doc_title_s">Коротка Назва *</label>
								</b-col>
								<b-col sm="4">
									<b-form-input :state="is_valid_small_name" v-model="form.small_name" maxlength="130" id="doc_title_s" size="sm"></b-form-input>
									<b-form-invalid-feedback id="input-live-feedback">
										Потрібно заповнити коротку назву
									</b-form-invalid-feedback>
								</b-col>
							</b-row>

							<b-row class="doc_tov_s mt-3">
								<b-col sm="3">
									<label for="doc_tov_s">Виберiть з випадаючого списку організацію *</label>
								</b-col>
								<b-col sm="4">
									<b-form-group label="">
										<div class="select_step width-mobile-auto">
											<b-form-select
												:state="is_valid_tov"
												value-field="id"
												text-field="small_title"
												v-model="form.tov_id"
												:options="tov_list" required></b-form-select>
										</div>
									</b-form-group>
								</b-col>
							</b-row>

							<b-row class="doc_tov_s mt-3">
								<b-col sm="3">
									<label for="doc_tp_s">Виберiть з випадаючого списку тип *</label>
								</b-col>
								<b-col sm="4">
									<b-form-group label="">
										<div class="select_step width-mobile-auto">
											<b-form-select
												:state="is_valid_type"
												value-field="id"
												text-field="name"
												v-model="form.type_id"
												:options="type_list" required></b-form-select>
										</div>
									</b-form-group>
								</b-col>
							</b-row>
						</b-container>
					</b-col>
				</b-row>
			</b-container>


			<div class="button_block row mt-5 pb-5">

				<div class="next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3">
					<button class="btn btn-lg btn-block btn-outline-success waves-effect waves-themed"
							:disabled="!can_save"
							v-on:click="save"
					>
						<span class="fal fa-download mr-1"></span>
						Створити
					</button>
				</div>
			</div>

		</b-overlay>
	</div>
</template>

<script>

import {createHelpers} from 'vuex-map-fields';

const {mapFields} = createHelpers({
	getterType: 'user/getUserField',
});


export default {
	name: "create_enity",
	data: function data() {
		return {

			tov_list : [],
			type_list : [],

			is_load : false,
			form: {
				name: "",
				small_name : "",
				tov_id : 0,
				type_id : 0,
				user_id  : 0,
			},
		};
	},


	created() {
		this.loadEnityTypes();
		this.loadOrganizations();
	},

	methods : {

		clean_form() {
			this.form.name = "";
			this.form.small_name = "";
			this.form.tov_id = 0;
			this.form.type_id = 0;
		},

		async save() {
			this.is_load = true;
			this.form.user_id = this.cur_user;

			await api.put('/plombs/entity_create', this.form).then(({data}) => {
				this.clean_form();
				this.is_load = false;
				EventBus.$emit('show_toast', {err: "Operation Success", type: "success", title: "OK"})
			}).catch(err => {
				this.is_load = false;
				IMC_CORE.hideloading();
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
			});
		},

		async loadEnityTypes() {
			this.type_list = [];
			await api.get('/nfc/plombs/entities_groups').then(({data}) => {
				if(data.status == "operation_success") {
					this.type_list = data.data;
				}
			}).catch(err => {
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
			});
		},

		async loadOrganizations() {
			this.tov_list = [];
			await api.get('/organizations').then(({data}) => {
				if(data.status == "operation_success") {
					this.tov_list = data.data;
				}
			}).catch(err => {
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
			});
		}

	},

	computed  : {
		...mapFields({
			"cur_user" : "user.id"
		}),

		can_save() {
			return this.is_valid_name && this.is_valid_small_name && this.is_valid_tov && this.is_valid_type && parseInt(this.cur_user) > 0;
		},

		is_valid_name () {
			return this.form.name.length > 3;
		},
		is_valid_small_name () {
			return this.form.small_name.length > 2;
		},

		is_valid_tov () {
			return parseInt(this.form.tov_id) > 0;
		},

		is_valid_type() {
			return parseInt(this.form.type_id) > 0;
		}
	}
}
</script>

<style scoped>
	.custom-select {
		font-size: 1rem;
	}
</style>
